module.exports = __webpack_public_path__ + "media/images/liv__bottomBanner-95b2f765de0640149d5ec6f969234e68.png";